// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"styles__mapContainer___cbhDY","downTriangle":"styles__downTriangle___2eIcf","loader":"styles__loader___3RwYk"};